// extracted by css-extract-rspack-plugin
export default {"blankslateContainer":"blankslate-module__blankslateContainer__IsEny","blankslateContent":"blankslate-module__blankslateContent__M0G8h"};